<template>
  <div
    class="event-card"
    v-match-heights="{
      el: ['.event-head', '.event-body'],
      disabled: [575]
    }"
  >
    <div class="event-head">
      <div class="event-type">{{ event.eventType }}</div>
      <div class="date-time">
        <div class="date">{{ getDate(event.date) }}</div>
        <div class="time">{{ event.time }}</div>
      </div>
    </div>
    <div class="event-body">
      <div class="event-info">
        <div class="event-title">{{ event.title }}</div>
        <div class="views-count" v-if="belongsToCollege">
          <span v-if="event.views !== 0 && !empty">{{ event.views }}</span>
          <span v-else class="no-views">No</span>
          views
        </div>
        <div
          class="event-description"
          v-if="event.eventType === 'Game Schedule'"
        >
          <div class="team">{{ event.teamA }}</div>
          <div class="vs">VS</div>
          <div class="team">{{ event.teamB }}</div>
        </div>
        <div class="event-description" v-else>
          <p class="w-space-preline">{{ event.description }}</p>
        </div>
      </div>
    </div>
    <div class="event-footer">
      <router-link
        :to="
          $route.params.id
            ? `/${profileId}/college/${$route.params.id}/event/${event.id}`
            : `/${profileId}/college/event/${event.id}`
        "
      >
        <div class="view-details">
          View Details
          <a-icon type="double-right" />
        </div>
      </router-link>
      <div
        class="button-wrap"
        :class="{ 'single-button': viewOnly }"
        v-if="!$route.params.id && exceptCollegeNormalCoach()"
      >
        <span v-if="!viewOnly">
          <a-button
            type="primary"
            icon="file-add"
            class="save-button"
            @click="changeForm(event)"
            >Edit</a-button
          >
        </span>
        <span>
          <a-popconfirm
            title="Sure you want to delete this event?"
            @confirm="deleteEvent(event.id)"
            ok-text="Yes"
            cancel-text="No"
          >
            <a-button type="danger" icon="delete">Delete</a-button>
          </a-popconfirm>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import isEmpty from "@/utils/isEmpty.js";
import { Base } from "@/models";
const COLLEGE_EVENT_STORE_KEY = "collegeEventStore";

export default {
  name: "card",
  props: ["event", "id", "viewOnly"],
  data() {
    return {
      empty: true
    };
  },
  mounted() {
    this.empty = isEmpty(this.event.views);
  },
  computed: {
    profileId() {
      return Base.profileId();
    },
    localCollegeId() {
      return localStorage["college-id"];
    },
    belongsToCollege() {
      return (
        !this.$route.params.id || this.$route.params.id === this.localCollegeId
      );
    }
  },
  methods: {
    getDate(date) {
      let d = new Date(date);
      return `${moment()
        .month(d.getUTCMonth())
        .format("MMM")} ${d.getUTCDate()}`;
    },
    changeForm(val) {
      this.$emit("onChange", val);
    },
    async deleteEvent(id) {
      await this.$store.dispatch(
        `${COLLEGE_EVENT_STORE_KEY}/deleteCollegeEventsList`,
        {
          id,
          slug: "collegeevent"
        }
      );
      this.$emit("onDelete");
    }
  }
};
</script>

<style lang="scss"></style>
